// Liste des fonctions de filtres
    import functionsTris from '@/functions/tris.js'
    import functionsDate from '@/functions/date.js'


    const functionsFiltres = {
        // Filter simple
            filterBy(listeElements, id, type, sens){
                if(sens === undefined){
                    if(id === 'noLength'){
                        return listeElements.filter(function(element){
                            if(element[type].length === 0){
                                return element 
                            }
                        }) 
                    }else if(id !== ''){
                        return listeElements.filter(function(element){
                            if(element[type] === id){
                                return element 
                            }
                        })  
                    }else{
                        return listeElements
                    }
                }else if(sens === 'not'){
                    if(id === 'noLength'){
                        return listeElements.filter(function(element){
                            if(element[type].length != 0){
                                return element 
                            }
                        }) 
                    }else if(id !== ''){
                        return listeElements.filter(function(element){
                            if(element[type] != id){
                                return element 
                            }
                        })  
                    }else{
                        return listeElements
                    }
                }
            },

            filterElementBy(element, id, type, sens){
                if(sens === undefined){
                    if(id === 'noLength'){
                        if(element[type].length === 0){
                            return element 
                        }
                    }else if(id !== ''){
                        if(element[type] === id){
                            return element 
                        }
                    }else{
                        return listeElements
                    }
                }else if(sens === 'not'){
                    if(id === 'noLength'){
                        if(element[type].length != 0){
                            return element 
                        }
                    }else if(id !== ''){
                        if(element[type] != id){
                            return element 
                        }
                    }else{
                        return listeElements
                    }
                }
            },

            filterByDeux(listeElements, id, type, typeDeux, sens){
                if(sens === undefined){
                    if(id === 'noLength'){
                        return listeElements.filter(function(element){
                            if(element[type][typeDeux].length === 0){
                                return element 
                            }
                        }) 
                    }else if(id !== ''){
                        return listeElements.filter(function(element){
                            if(element[type][typeDeux] === id){
                                return element 
                            }
                        })  
                    }else{
                        return listeElements
                    }
                }else if(sens === 'not'){
                    if(id === 'noLength'){
                        return listeElements.filter(function(element){
                            if(element[type][typeDeux].length != 0){
                                return element 
                            }
                        }) 
                    }else if(id !== ''){
                        return listeElements.filter(function(element){
                            if(element[type][typeDeux] != id){
                                return element 
                            }
                        })  
                    }else{
                        return listeElements
                    }
                }
            },

            filterByTrois(listeElements, id, type, typeDeux, typeTrois, sens){
                return listeElements.filter(function(element){
                    if(element[type][typeDeux][typeTrois] === id){
                        return element 
                    }
                })  
            },

            testDoublons(listeElements, id, type){
                if(id === ''){
                    return false
                }else{
                    if(this.filterBy(listeElements, id, type).length > 0){
                        return true
                    }else{
                        return false
                    }
                }
            },

            filterByDoublonsTrois(listeElements, type, typeDeux, typeTrois){
                let listeValeurs = []
                listeElements.forEach(element => {
                    listeValeurs.push(element[type][typeDeux][typeTrois])
                })

                return [...new Set(listeValeurs)]
            },

        //  Filter non vide
            filterByNotEmpty(listeElements, type){
                return listeElements.filter(function(element){
                    if(type === ''){
                        if(element !== ''){
                            return element 
                        }
                    }else{
                        if(element[type] !== ''){
                            return element 
                        }
                    }
                }) 
            },

        // Filter multi
            filterByMulti(listeElements, id, type, typeElement){
                if(id === 'noLength'){
                    return listeElements.filter(function(element){
                        if(element[type].length === 0){
                            return element 
                        }
                    }) 
                }else if(id !== ''){ 
                    return listeElements.filter(element => {
                        return element[type].some(item => 
                            item[typeElement] === id)
                    })
                }else{
                    return listeElements
                }
            },


            filterByListe(listeElements, id, type){
                return listeElements.filter(element => {
                    if(element[type])
                    return element[type].some(item => item === id)
                })
            },

            filterByListeDeux(listeElements, id, type, typeDeux){
                return listeElements.filter(element => {
                    return element[type][typeDeux].some(item => item === id)
                })
            },

            filterByListeTrois(listeElements, id, type, typeDeux, typeTrois){
                return listeElements.filter(element => {
                    return element[type][typeDeux][typeTrois].some(item => {
                        if(item === id){
                            return item
                        }
                    })
                })
            },
            
            filterInArray(listeElements, id){
                return listeElements.filter(element => {
                    return id.some(item => item === element)
                })
            },

            filterInTypeArray(listeElements, id, type){
                return listeElements.filter(element => {
                    return element[type].includes(id)
                    // return id.some(item => item === element)
                })
            },

            filterInTypeArrayDeux(listeElements, id, type, typeDeux){
                return listeElements.filter(element => {
                    return element[type][typeDeux].includes(id)
                })
            },

            filterInListe(listeElements, id, type){
                return listeElements.filter(element => {
                    return id.some(item => item === element[type])
                })
            },

            filterInListeDeux(listeElements, id, type, typeDeux){
                return listeElements.filter(element => {
                    return id.some(item => item === element[type][typeDeux])
                })
            },

            filterInListeTrois(listeElements, id, type, typeDeux, typeTrois){
                return listeElements.filter(element => {
                    return id.some(item => item === element[type][typeDeux][typeTrois])
                })
            },

            filterByMultiDeux(listeElements, id, type, typeElement, typeElementElement){
                if(id === 'noLength'){
                    return listeElements.filter(function(element){
                        if(element[type].length === 0){
                            return element 
                        }
                    }) 
                }else if(id !== ''){ 
                    return listeElements.filter(element => {
                        return element[type].some(item => {
                            return item[typeElement].some(item => item[typeElementElement] === id)
                        })
                    })
                }else{
                    return listeElements
                }
            },

        // Filter keyword
            filterByKeyword(listeElements, keyword, type){
                if(keyword != ''){
                    return listeElements.filter(function(element){
                        return (
                            element[type].toLowerCase().indexOf(keyword.toLowerCase()) >= 0
                            ? element
                            : ''
                        )
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterByKeywordDeux(listeElements, keyword, type, typeDeux){
                if(keyword != ''){
                    return listeElements.filter(function(element){
                        return (
                            element[type][typeDeux].toLowerCase().indexOf(keyword.toLowerCase()) >= 0
                            ? element
                            : ''
                        )
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

        // Filter entre 2 listes
            filterSomeListe(listeElements, type, listeItems, sens){
                if(sens === undefined){
                    return listeElements.filter(element => {
                        return listeItems.some(item => item === element[type]);
                    });
                }else if(sens === 'not'){
                    return listeElements.filter(element => {
                        return listeItems.some(item => item != element[type]);
                    });
                }else{
                    return listeElements
                }
            },

            filterSome(listeElements, type, listeItems, typeItem, sens){
                if(sens === undefined){
                    return listeElements.filter(element => {
                        return listeItems.some(item => item[typeItem] === element[type]);
                    });
                }else if(sens === 'not'){
                    return listeElements.filter(element => {
                        return listeItems.some(item => item[typeItem] != element[type]);
                    });
                }else{
                    return listeElements
                }
            },
            
            filterSomeDeux(listeElements, type, listeItems, typeItem, typeItemDeux){
                return listeElements.filter(element => {
                    return listeItems.some(item => {
                        return item[typeItem].some(it => it[typeItemDeux] === element[type]) 
                    });
                });
            },

            filterSomeMulti(listeElements, typeElement, type, listeItems, typeItem, id){
                return listeElements.filter(element => {
                    return element[typeElement].some(el => {
                        if(el[type] != id){
                            return listeItems.some(item => item[typeItem] === el[type])
                        }
                    })
                });
            },

        // Filter ayant au moins 1 element
            filtresListeWithElement(listeElements, type, listeItems, typeItem){
                const listeItemTrier = new Set(listeItems.map(item => item[typeItem]));
                
                return listeElements.filter(element => listeItemTrier.has(element[type]));
            },

        // Filter range
            filterRange(listeElements, type, min, max){
                if(min !== '' && max !== ''){
                    return listeElements.filter(function(element){
                        if(element[type] <= max && element[type] >= min){
                            return element
                        }
                    }.bind(this))
                }else{
                    // return listeElements
                }
            },

            filterRangeNoType(listeElements, min, max){
                if(min !== '' && max !== ''){
                    return listeElements.filter(function(element){
                        if(element <= Number(max) && element >= Number(min)){
                            return element
                        }
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterRangePlanning(listeElements, type, min, max, listeItems){
                if(min != '' && max != ''){
                    return listeElements.filter(function(element){
                        let planning = this.filterBy(listeItems, 'avion', element[type])

                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterRangeCalcul(listeElements, type, typeCalcul, min, max, pourcent, div){
                return listeElements.filter(function(element){
                    let calcul = 0
                    if(element[type].length > 0){
                        element[type].forEach(item =>{
                            calcul += item[typeCalcul]
                        })

                        calcul = calcul * pourcent / div
                    }else{
                        calcul = 0

                    }
                    if(calcul >= min && calcul <= max){
                        return element
                    }
                })
            },

            filterRangeDeux(listeElements, type, typeDeux, min, max){
                if(min != '' && max != ''){
                    return listeElements.filter(function(element){
                        if(element[type][typeDeux] <= max && element[type][typeDeux] >= min){
                            return element
                        }
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterRangeDate(listeElements, min, max){
                if(min != '' && max != ''){
                    let dateMinSplit = min.split('-')
                    let dateMaxSplit = max.split('-')
                    let dateMin = Number(dateMinSplit[0]+dateMinSplit[1]+dateMinSplit[2])
                    let dateMax = Number(dateMaxSplit[0]+dateMaxSplit[1]+dateMaxSplit[2])

                    return listeElements.filter(function(element){
                        let dateElement = Number(element.date.year_fr + element.date.month_fr + element.date.day_fr)
                        if(dateElement >= dateMin && dateElement <= dateMax){
                            return element
                        }
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterRangeDateDate(listeElements, min, max){
                if(min != '' && max != ''){
                    let dateMinSplit = min.split('-')
                    let dateMaxSplit = max.split('-')
                    let dateMin = Number(dateMinSplit[0]+dateMinSplit[1]+dateMinSplit[2])
                    let dateMax = Number(dateMaxSplit[0]+dateMaxSplit[1]+dateMaxSplit[2])

                    return listeElements.filter(function(element){
                        let dateElement = element.date.replaceAll('-', '')

                        if(dateElement >= dateMin && dateElement <= dateMax){
                            return element
                        }
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterDateType(listeElements, type, date){
                if(date !== ''){
                    let dateSplit = date.split('-')
                    let dateCompa = Number(dateSplit[0]+ dateSplit[1]+dateSplit[2])

                    return listeElements.filter(element =>{
                        let dateMinSplit = element[type].date_debut.split('-')
                        let dateMaxSplit = element[type].date_de_fin.split('-')
                        let dateMin = Number(dateMinSplit[0]+dateMinSplit[1]+dateMinSplit[2])
                        let dateMax = Number(dateMaxSplit[0]+dateMaxSplit[1]+dateMaxSplit[2])
                        if(dateMin <= dateCompa && dateCompa <= dateMax){
                            return element
                        }
                    })
                }
            },

            filterRangeDateType(listeElements, type, min, max){
                if(min != '' && max != ''){
                    let dateMinSplit = min.split('-')
                    let dateMaxSplit = max.split('-')
                    let dateMin = Number(dateMinSplit[0]+dateMinSplit[1]+dateMinSplit[2])
                    let dateMax = Number(dateMaxSplit[0]+dateMaxSplit[1]+dateMaxSplit[2])

                    return listeElements.filter(function(element){
                        let dateElement = Number(element[type].date.year_fr + element[type].date.month_fr + element[type].date.day_fr)

                        if(dateElement >= dateMin && dateElement <= dateMax){
                            return element
                        }
                    }.bind(this))
                }else{
                    return listeElements
                }
            },

            filterRangeDateElement(listeElements, date){
                let dateCompa = functionsDate.date(date).compa
                
                return listeElements.filter(element => {
                    let min = functionsDate.date(element.date.debut).compa 
                    let max = ''
                    if(element.date.fin !== ''){
                        max = functionsDate.date(element.date.fin).compa
                    }else{
                        max = dateCompa
                    }

                    if(Number(min) <= Number(dateCompa) && Number(dateCompa) <= Number(max)){
                        return element
                    }
                })
            },

            filterRangeByTime(listeElements, item, min, max){

                return listeElements.filter(function(element){
                    if(functionsDate.calculDureeTrajet(element, item) >= functionsDate.conversionTimeNum(min.h, min.m) && functionsDate.calculDureeTrajet(element, item) <= functionsDate.conversionTimeNum(max.h, max.m)){
                        return element
                    }
                })
            },

            filterByRangeArrondi(listeElements, item,  id){
                if(id === true){
                    return listeElements.filter(function(element){
                        let ar = Math.round((Math.floor((Math.ceil((Number(element.demande.eco) + Number(element.demande.aff) * 1.8 + Number(element.demande.pre) * 4) / 2) / item.siege) * 100) / 100 - Math.floor(Math.floor((Math.ceil((Number(element.demande.eco) + Number(element.demande.aff) * 1.8 + Number(element.demande.pre) * 4) / 2) / item.siege) * 100) / 100)) * 100)
                        if(ar <= 5 || ar >= 95){
                            return element
                        }
                    })
                }else{
                    return listeElements
                }
            },

            filterByRangeAR(listeElements, item, id, pm, AR){
                let min = AR - pm
                let max = AR + pm
                if(id === true){
                    return listeElements.filter(function(element){
                        let ar = Math.floor((Math.ceil((Number(element.demande.eco) + Number(element.demande.aff) * 1.8 + Number(element.demande.pre) * 4) / 2) / item.siege) * 100) / 100
                        if(min < ar  && ar < max){
                            return element
                        }
                    })
                }else{
                    return listeElements
                }
            },

        // Date
            filterByDay(listeElements, index, type){
                if(index != ''){
                    return listeElements.filter(publication => {
                        let dateObj = new Date(publication[type]);
                        return dateObj.getDay() === index;
                    });
                }else{
                    return listeElements
                }
            },

            filterByDays(listeElements, listeIndex, type){
                if(listeIndex.length > 0){
                    return listeElements.filter(element => {
                        let dateObj = new Date(element[type]);
                        return listeIndex.some(index => index ===  dateObj.getDay());
                    });
                }else{
                    return listeElements
                }
            },

            filterMap(listeElements, type){
                return [...new Set(listeElements.map(element => element[type]))]
            },

            filterByMissing(listeElements, listeItems){
                return listeElements.filter(item => !listeItems.includes(item));
            },

        // Autres
            filterByPlanning(listeElements, typeElement, typeElementDeux, typeElementTrois, listeItems, typeItem, div, monElement){
                return listeElements.filter(element => {
                    let max = Math.round((Math.ceil((Number(monElement.distance) * 2 / Number(this.filterBy(dataBase.modelesavions, element.modele, 'modele')[0].vitesse) + 2) * 60 / 15) * 15 / 60) * 100 / div * 100) / 100
                    element[typeElementDeux] = listeItems.filter(item =>{
                        if(item[typeItem] === element[typeElement]){
                            return item
                        }
                    })
                    element.planning = functionsTris.trierPlanning(element.planning)
                    let count = 0

                    element[typeElementDeux].forEach(el => {
                        count += el[typeElementTrois]
                    })
                    element.count = count

                    element.pourcentage = count * 100 / div

                    if(element.pourcentage <= 100 - max){
                        return element
                    }
                })
            }
        
    }

    export default functionsFiltres


// WEBPACK FOOTER //
// ./src/functions/filter.js